import React, { useEffect, useState, useRef } from 'react'
import Destination from '../hero/hero-rslhome/Destination'
import HotelCalanderFrom from '../hero/hero-rslhome/HotelCalanderFromHoliday'
import GuestSearch from '../rental-list/common/GuestSearchHoliday'
// import HotelDestinationCity from "../hero/hero-rslhome/HotelDestinationCityHoliday";
import HotelDestinationCity from '../hero/hero-rslhome/holiday/ActivityDestinationCityStaycation'
import ActivityListStaycation from '../hero/hero-rslhome/holiday/ActivityListStaycation'
import HotelDestinationCountry from '../../components/hero/hero-rslhome/HotelDestinationCountryHoliday'
import { useRouter } from 'next/router'
// Redux
import { useDispatch, useSelector } from '../../redux/store'
import { searchTour, searchTourList } from '../../redux/slices/tourpackage'
import CircularProgress from '@mui/material/CircularProgress'
import Skeleton from '@mui/material/Skeleton'
import { createTheme, ThemeProvider } from '@mui/material/styles'

// Create a custom theme with the desired CircularProgress color
const customTheme = createTheme({
  components: {
    MuiCircularProgress: {
      styleOverrides: {
        root: {
          color: '#ffffff', // Change to your desired color
          width: '20px !important',
          height: '20px !important'
        }
      }
    }
  }
})

const HotelsRSL = () => {
  const router = useRouter()
  const dispatch = useDispatch()
  const autocompleteFirst = useRef()
  const autocompleteNext = useRef()
  const { tourSearchRes, tourSearchListRes } = useSelector(state => state.tour)
  const [isButtonDisabled, setIsButtonDisabled] = useState(true)
  const [countryValue, setCountryValue] = useState('')
  const [cityValue, setCityValue] = useState([])
  const [searchProduct, setSearchProduct] = useState([])
  const [selectedValue, setSelectedValue] = useState(null)
  const [cityValue1, setCityValue1] = useState([])
  const [searchProduct1, setSearchProduct1] = useState([])
  const [selectedValue1, setSelectedValue1] = useState(null)
  const [checkInDate, setCheckInDate] = useState('')
  const [loader, setLoader] = useState(false)
  const [loaderSearch, setLoaderSearch] = useState(false)
  const [checkOutDate, setCheckOutDate] = useState('')
  const [guetsValue, setGuestValue] = useState({
    Adults: 1,
    Children: 0,
    Rooms: 1
  })
  const [loading, setLoading] = useState(true)
  const [cityLoading, setCityLoading] = useState(true)

  const [isFormValid, setIsFormValid] = useState(true)
  const [errorMessage, setErrorMessage] = useState('')
  const [isSubmitClicked, setIsSubmitClicked] = useState(false)

  const [focusFirst, setFocusFirst] = useState(true)
  const [focusNext, setFocusNext] = useState(false)

  useEffect(() => {
    if (autocompleteFirst.current) {
      autocompleteFirst.current.querySelector('input').focus({ preventScroll: true })
    }
  }, [])

  useEffect(() => {
    if (selectedValue?.name !== '' && selectedValue !== null) {
      if (autocompleteNext.current) {
        autocompleteNext.current.querySelector('input').focus({ preventScroll: true })
        setFocusNext(true)
      }
    }
  }, [selectedValue])

  useEffect(() => {
    setIsSubmitClicked(false)
    // if(countryValue&&countryValue!==""&&cityValue&&cityValue!==""&&checkInDate&&checkInDate!==""&&checkOutDate&&checkOutDate!==""){
    if (searchProduct && searchProduct.length !== 0 && searchProduct !== '') {
      setIsButtonDisabled(false)
    } else {
      setIsButtonDisabled(true)
    }
  }, [searchProduct, searchProduct1])

  const [isCalled, setIsCalled] = useState(false)

  useEffect(() => {
    setLoading(true)
    setCityLoading(true)
    setIsCalled(true)
    const timerId = setTimeout(() => {
      if (searchProduct.length >= 3) {
        setCityValue([])
        dispatch(
          searchTour({ query: searchProduct.length > 0 ? searchProduct : '' })
        )
      } else if (searchProduct.length === 0) {
        dispatch(searchTour({ query: '' }))
      }
    }, 500)

    return () => {
      clearTimeout(timerId)
    }
  }, [searchProduct])

  useEffect(() => {
    setLoading(true)
    setCityLoading(true)
    const timerId = setTimeout(() => {
      if (searchProduct.length >= 3) {
        setCityValue1([])
        dispatch(
          searchTourList({
            cityName: searchProduct.length > 0 ? searchProduct : '',
            search: searchProduct1.length > 0 ? searchProduct1 : ''
          })
        )
      }
    }, 500)

    return () => {
      clearTimeout(timerId)
    }
  }, [searchProduct1, searchProduct])

  // Testing

  const handleBooking = () => {
    setLoader(true)

    router.push({
      pathname: '/holidays/holidays',
      query: {
        country: countryValue,
        cityName: selectedValue?.cityName,
        name: selectedValue?.name,
        // checkIn: checkInDate,
        // checkOut: checkOutDate,
        adult: guetsValue.Adults,
        child: guetsValue.Children,
        rooms: guetsValue.Rooms,
        productId: selectedValue?._id
        // time: moment(bookPickUpDate).format("YYYY-MM-DD hh:mm:ss A"),
      }
    })
  }

  const handleBookingSearch = () => {
    setIsSubmitClicked(true)
    if (selectedValue?.name !== '' && selectedValue !== null) {
      setLoaderSearch(true)
      setLoader(true)
      router.push({
        pathname: '/holidays/holidays',
        query: {
          country: countryValue,
          cityName: selectedValue?.cityName,
          name: selectedValue1?.name,
          adult: guetsValue.Adults,
          child: guetsValue.Children,
          rooms: guetsValue.Rooms,
          productId: selectedValue1?._id
          // time: moment(bookPickUpDate).format("YYYY-MM-DD hh:mm:ss A"),
        }
      })
    } else {
      setIsFormValid(false)
      setErrorMessage('Please fill in all fields.')
    }
  }


  useEffect(() => {
    if (isCalled) {
      if (tourSearchRes !== undefined) {
        // Create an empty object
        setIsCalled(false)
        const myObjectDestination = {}
        const childArrayDestination = []
        const myObjectStaycationList = {}
        const childArrayStaycationList = []
        const allObjectDestination = {}
        const allArrayDestination = []
        const mainArray = []
        setCityLoading(false)
        setLoading(false)
        if (tourSearchRes?.destination !== undefined) {
          if (tourSearchRes?.destination.length > 0) {
            tourSearchRes?.destination.map(data => {
              myObjectDestination.label = 'City'
              myObjectDestination.img = '/img/general/flag.png'
              childArrayDestination.push(data)
              myObjectDestination.values = childArrayDestination
              //
            })
          } else {
            myObjectDestination.label = 'City'
            myObjectDestination.values = []
          }
        }

        if (tourSearchRes?.countryList !== undefined) {
          if (tourSearchRes?.countryList.length > 0) {
            tourSearchRes?.countryList.map(data => {
              myObjectStaycationList.label = 'Country'
              myObjectStaycationList.img = '/img/general/iconnew.png'
              childArrayStaycationList.push(data)
              myObjectStaycationList.values = childArrayStaycationList
              //
            })
          } else {
            myObjectStaycationList.label = 'Country'
            myObjectStaycationList.values = []
          }
        }

        if (tourSearchRes?.allCityType !== undefined) {
          if (tourSearchRes?.allCityType.length > 0) {
            tourSearchRes?.allCityType.map(data => {
              allObjectDestination.label =
                data?.countryName || 'Matched Location'
              allObjectDestination.img = '/img/general/iconnew.png'
              allArrayDestination.push(data)
              allObjectDestination.values = allArrayDestination
              //
            })
          } else {
            allObjectDestination.label = 'Matched Location'
            allObjectDestination.values = []
          }
        }

        mainArray.push(allObjectDestination, myObjectDestination, myObjectStaycationList)

        setCityValue(mainArray)
      }
    }
  }, [tourSearchRes])

  useEffect(() => {
    // if (tourSearchRes.length > 0) {
    if (tourSearchListRes !== undefined) {
      // Create an empty object
      const myObjectDestination = {}
      const childArrayDestination = []
      const myObjectHolidayList = {}
      const childArrayHolidayList = []
      const mainArray = []
      setLoading(false)
      if (tourSearchListRes?.topAttraction !== undefined) {
        if (tourSearchListRes?.topAttraction.length > 0) {
          tourSearchListRes?.topAttraction.map(data => {
            myObjectDestination.label = 'Top Holiday'
            myObjectDestination.img = '/img/general/flag.png'
            childArrayDestination.push(data)
            myObjectDestination.values = childArrayDestination
            //
          })
        } else {
          myObjectDestination.label = 'Top Holiday'
          myObjectDestination.values = []
        }
      }

      if (tourSearchListRes?.holidayList !== undefined) {
        if (tourSearchListRes?.holidayList.length > 0) {
          tourSearchListRes?.holidayList.map(data => {
            myObjectHolidayList.label = 'Holiday'
            myObjectHolidayList.img = '/img/general/iconnew.png'
            childArrayHolidayList.push(data)
            myObjectHolidayList.values = childArrayHolidayList
            //
          })
        } else {
          myObjectHolidayList.label = 'Holiday'
          myObjectHolidayList.values = []
        }
      }
      if (tourSearchListRes.holidayList.length === 0) {
        setSelectedValue1({
          name: ''
        })
      }

      mainArray.push(myObjectDestination, myObjectHolidayList)
      setCityValue1(mainArray)
    }
  }, [tourSearchListRes])

  return (
    <>
      <div className='activites_rsl'>
        <div className='activites_input'>


          <div className='Activities Activities-new py-5'>
            <HotelDestinationCity
              setCityValue={setCityValue}
              cityValue={cityValue}
              searchProduct={searchProduct}
              setSearchProduct={setSearchProduct}
              setSelectedValue={setSelectedValue}
              selectedValue={selectedValue}
              // label="Select your City?"
              label='Select your City?'
              placeholder='Search'
              setLoading={setCityLoading}
              loading={cityLoading}
              autocompleteFirst={autocompleteFirst}
              error={isSubmitClicked && selectedValue === null ? true : false}
              helperText={
                isSubmitClicked && selectedValue === null ? 'Required' : ''
              }
            />
            <ActivityListStaycation
              setCityValue={setCityValue1}
              cityValue={cityValue1}
              searchProduct={searchProduct1}
              setSearchProduct={setSearchProduct1}
              setSelectedValue={setSelectedValue1}
              selectedValue={selectedValue1}
              label='Holidays'
              placeholder='Search'
              setLoading={setLoading}
              loading={loading}
              autocompleteNext={autocompleteNext}
            // error={isSubmitClicked && selectedValue1 === null ? true : false}
            // helperText={isSubmitClicked && selectedValue1 === null ? 'Required' : ''}
            />

            <div className='trip-booking__btn'>
              <ThemeProvider theme={customTheme}>
                <button
                  className='mainSearch__submit btn-1 button -dark-4 py-10 px-15  bg-dark-3 text-white w-100'
                  onClick={handleBookingSearch}
                >
                  {loader ? <CircularProgress /> : 'Search'}
                </button>
              </ThemeProvider>
            </div>

            {/* <HotelDestinationCity
              setCityValue={setCityValue}
              cityValue={cityValue}
              searchProduct={searchProduct}
              setSearchProduct={setSearchProduct}
              setSelectedValue={setSelectedValue}
              selectedValue={selectedValue}
              // label="Select your City? *"
              label="Select your City?"
              placeholder="Search"
              setLoading={setLoading}
              loading={loading}
              autocompleteFirst={autocompleteFirst}
              error={isSubmitClicked && selectedValue === null ? true : false}
              helperText={
                isSubmitClicked && selectedValue === null ? "Required" : ""
              }
            />
            <ActivityListStaycation
              setCityValue={setCityValue1}
              cityValue={cityValue1}
              searchProduct={searchProduct1}
              setSearchProduct={setSearchProduct1}
              setSelectedValue={setSelectedValue1}
              selectedValue={selectedValue1}
              label="Holidays"
              placeholder="Search"
              setLoading={setLoading}
              loading={loading}
              autocompleteNext={autocompleteNext}
              // error={isSubmitClicked && selectedValue1 === null ? true : false}
              // helperText={isSubmitClicked && selectedValue1 === null ? 'Required' : ''}
            /> */}
          </div>
        </div>
      </div>
    </>
  )
}

export default HotelsRSL
